import { render, staticRenderFns } from "./CoverSetting.vue?vue&type=template&id=e19c0374&scoped=true&"
import script from "./CoverSetting.vue?vue&type=script&lang=js&"
export * from "./CoverSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19c0374",
  null
  
)

export default component.exports